module.exports = __webpack_public_path__ + "img/wuye.1c31c51e.png";